// mm:ss로 변환

export const formatTime = (time, unit = 's') => {
  if (!time) return "00:00";
  
  // 밀리초(ms)로 들어오면 초(s)로 변환
  const totalSeconds = unit === 'ms' ? Math.round(time / 1000) : Math.floor(time);
  
  const mm = String(Math.floor(totalSeconds / 60)).padStart(2, "0");
  const ss = String(totalSeconds % 60).padStart(2, "0");
  
  return `${mm}:${ss}`;
};